import React, { useState, useEffect, createContext, useContext } from "react";
import "./App.css";

// ========== LANGUAGE CONTEXT ==========
const LangContext = createContext();

const translations = {
  "pt-BR": {
    badge: "Transporte Executivo no Rio de Janeiro",
    heroTitle: "Transfer Premium no Rio de Janeiro",
    heroSubtitle:
      "Do Aeroporto ao Seu Destino com Segurança, Conforto e Pontualidade",
    heroCta: "Solicitar Cotação",
    heroCtaForm: "Solicitar cotação",
    heroSecondary: "Ver Destinos",
    featuresTitle: "Por Que escolher a Rio Executive Transfer",
    featPrice: "Preço Justo",
    featPriceDesc: "Valores competitivos sem surpresas",
    featSafety: "Segurança Garantida",
    featSafetyDesc: "Motoristas experientes e veículos vistoriados",
    featPunctual: "Pontualidade",
    featPunctualDesc: "Monitoramento de voos em tempo real",
    featFleet: "Frota Variada",
    featFleetDesc: "Sedan, SUV e veículos especiais",
    featExtras: "Extras Inclusos",
    featExtrasDesc: "Atendimento personalizado e cadeirinha",
    feat24h: "Atendimento 24h",
    feat24hDesc: "Disponível todos os dias do ano",
    routesTitle: "Rotas Mais Populares",
    routeConsult: "Consulte valores",
    routeAll: "Ver todas as rotas",
    howTitle: "Simples e Rápido",
    step1Title: "Solicite sua Cotação",
    step1Desc: "Preencha o formulário ou entre em contato via WhatsApp",
    step2Title: "Receba Confirmação",
    step2Desc: "Resposta rápida com valor e detalhes da viagem",
    step3Title: "Seu Motorista te Aguarda",
    step3Desc: "Com placa personalizada no aeroporto ou endereço",
    vehiclesTitle: "Veículos Confortáveis",
    vehicleExec: "Executivo",
    vehicleExecPremium: "Executivo Premium",
    vehicleSuv: "SUV",
    vehicleColetivos: "Coletivos",
    vehicleBlindados: "Blindados",
    execPass: "4 passageiros + bagagens de mão",
    execPremiumPass: "4 passageiros + bagagens de mão",
    suvPass: "4 passageiros + bagagens de mão",
    coletivosPass: "De 12 a 46 passageiros",
    blindadosPass: "4 passageiros + bagagens de mão",
    vehicleMinivan: "Minivan",
    minivanPass: "5 a 8 passageiros + bagagens de mão",
    featAc: "Carros novos",
    featPunctual2: "Veículos Confortáveis",
    featPersonal: "Motoristas Experientes",
    testiTitle: "O Que Dizem Nossos Clientes",
    galleryTitle: "Nossa Galeria",
    paymentTitle: "Pagamento Facilitado",
    paymentSub: "Pagamento seguro e em múltiplas moedas",
    payCard: "Cartão de Crédito/Débito",
    payPix: "Pix",
    payCash: "Dinheiro (Real, Dólar, Euro)",
    payOnline: "PayPal / Stripe",
    ctaTitle: "Pronto para Viajar com Conforto?",
    ctaSub:
      "Solicite sua cotação agora mesmo pelo WhatsApp e receba atendimento em minutos.",
    ctaBtn: "Falar no WhatsApp",
    footerLinks: "Links Rápidos",
    footerContact: "Contato",
    footerCopy: "© 2026 Rio Executive Transfer. Todos os direitos reservados.",
    navRoutes: "Rotas",
    navVehicles: "Veículos",
    navGallery: "Galeria",
    navContact: "Contato",
    footerDesc:
      "Transporte Executivo no Rio de Janeiro. Conforto, segurança e pontualidade em cada detalhe.",
    transportExec: "Transporte Executivo",
    transportExecDesc: "Conforto e segurança em cada detalhe.",
    tourism: "Turismo Personalizado",
    tourismDesc: "Roteiros exclusivos do seu jeito.",
    transfers: "Traslados",
    transfersDesc: "Aeroportos, hotéis, eventos e muito mais.",
    cadastur: "Cadastrado no Cadastur",
    cadasturDesc: "Turismo legal e seguro.",
    schedule:
      "Agende seu horário e viva experiências únicas no Rio de Janeiro.",
    // Form translations
    formTitle: "Solicitar Cotação Grátis",
    formOrigin: "Origem",
    formDestination: "Destino",
    formDate: "Data",
    formTime: "Horário",
    formPassengers: "Passageiros",
    formBaggage: "Bagagens",
    formNameOrFlight: "Número do voo (opcional)",
    formChildSeat: "Precisa de cadeirinha infantil?",
    formWifi: "Precisa de WiFi no carro?",
    formSubmit: "Solicitar Cotação Grátis",
    formPlaceholderOrigin: "Selecione a origem",
    formPlaceholderDest: "Ex: Copacabana",
    formPlaceholderName: "Ex: LA4500",
    originGaleao: "Aeroporto Galeão",
    originSantosDumont: "Aeroporto Santos Dumont",
    originOther: "Outro endereço",
    // City Tour
    cityToursTitle: "City Tours no Rio",
    tourClassic: "City Tour Clássico",
    tourComplete: "City Tour Completo",
    tourHistoric: "City Tour Histórico",
    tourNature: "City Tour Natureza",
    tourBeaches: "City Tour Praias",
    tourCultural: "City Tour Cultural",
    tourCustom: "City Tour Personalizado",
    tourCustomDesc:
      "Monte seu roteiro exclusivo de acordo com suas preferências",
    clickToReturn: "Clique para voltar",
    cityTourLabel: "CITY TOUR",
    tourCustomCta: "MONTE SEU ROTEIRO",
    tourCustomMsg: "Olá! Gostaria de montar um City Tour personalizado.",
    itemCristo: "Cristo Redentor",
    itemPaoAcucar: "Pão de Açúcar",
    itemEscadaria: "Escadaria Selarón",
    itemArcosLapa: "Arcos da Lapa",
    itemMaracana: "Maracanã (área externa)",
    itemCatedral: "Catedral Metropolitana",
    itemMiranteDonaMarta: "Mirante Dona Marta",
    itemPracaXV: "Praça XV",
    itemPacoImperial: "Paço Imperial",
    itemRealGabinete: "Real Gabinete Português de Leitura",
    itemConfeitariaColombo: "Confeitaria Colombo",
    itemTheatroMunicipal: "Theatro Municipal do Rio de Janeiro",
    itemJardimBotanico: "Jardim Botânico do Rio de Janeiro",
    itemParqueLage: "Parque Lage",
    itemFlorestaTijuca: "Floresta da Tijuca",
    itemPraiaCopacabana: "Praia de Copacabana",
    itemPraiaIpanema: "Praia de Ipanema",
    itemArpoador: "Arpoador",
    itemLeblon: "Leblon",
    itemSaoConrado: "São Conrado",
    itemMuseuAmanha: "Museu do Amanhã",
    itemMuseuArteRio: "Museu de Arte do Rio",
    itemAquario: "AquaRio",
    itemBoulevardOlimpico: "Boulevard Olímpico",
    //Destinos
    destinosTitle: "Destinos",
    destinoLagosTitle: "Região dos Lagos",
    destinoLagosSubtitle: "Praias paradisíacas e águas cristalinas.",
    destinoCostaVerdeTitle: "Costa Verde",
    destinoCostaVerdeSubtitle: "Natureza exuberante e mar deslumbrante.",
    destinoSerranaTitle: "Região Serrana",
    destinoSerranaSubtitle: "Clima ameno, montanhas e muita tranquilidade.",
    destinoSaoPauloTitle: "São Paulo",
    destinoSaoPauloSubtitle: "Metrópole vibrante e destinos incríveis.",
    destinoEspiritoSantoTitle: "Espírito Santo",
    destinoEspiritoSantoSubtitle:
      "Belezas naturais e praias para todos os estilos.",
    destinoMinasGeraisTitle: "Minas Gerais",
    destinoMinasGeraisSubtitle: "História, cultura e paisagens que encantam.",
    destinoOceanicaTitle: "Região Oceânica de Niterói",
    destinoOceanicaSubtitle: "Praias incríveis pertinho de você.",
    destinoNiteroiTitle: "Niterói",
    destinoNiteroiSubtitle: "Praias urbanas e qualidade de vida todos os dias.",
  },
  "en-US": {
    badge: "Executive Transport in Rio de Janeiro",
    heroTitle: "Premium Transfer in Rio de Janeiro",
    heroSubtitle:
      "From the Airport to Your Destination with Safety, Comfort and Punctuality",
    heroCta: "Request a Quote",
    heroCtaForm: "Request a quote",
    heroSecondary: "View Destinations",
    featuresTitle: "Why Choose Rio Executive Transfer",
    featPrice: "Fair Price",
    featPriceDesc: "Competitive rates with no surprises",
    featSafety: "Guaranteed Safety",
    featSafetyDesc: "Experienced drivers and inspected vehicles",
    featPunctual: "Punctuality",
    featPunctualDesc: "Real-time flight monitoring",
    featFleet: "Varied Fleet",
    featFleetDesc: "Sedan, SUV and special vehicles",
    featExtras: "Extras Included",
    featExtrasDesc: "Personalized service and child seat",
    feat24h: "24/7 Service",
    feat24hDesc: "Available every day of the year",
    routesTitle: "Most Popular Routes",
    routeConsult: "Check prices",
    routeAll: "View all routes",
    howTitle: "Simple and Fast",
    step1Title: "Request Your Quote",
    step1Desc: "Fill out the form or contact us via WhatsApp",
    step2Title: "Receive Confirmation",
    step2Desc: "Quick response with price and trip details",
    step3Title: "Your Driver Awaits",
    step3Desc: "With a personalized sign at the airport or address",
    vehiclesTitle: "Comfortable Vehicles",
    vehicleExec: "Executive",
    vehicleExecPremium: "Executive Premium",
    vehicleSuv: "SUV",
    vehicleColetivos: "Group Transport",
    vehicleBlindados: "Armored",
    execPass: "4 passengers + hand luggage",
    execPremiumPass: "4 passengers + hand luggage",
    suvPass: "4 passengers + hand luggage",
    coletivosPass: "12 to 46 passengers",
    blindadosPass: "4 passengers + hand luggage",
    vehicleMinivan: "Minivan",
    minivanPass: "5 to 8 passengers + hand luggage",
    featAc: "New cars",
    featPunctual2: "Comfortable vehicles",
    featPersonal: "Experienced drivers",
    testiTitle: "What Our Clients Say",
    galleryTitle: "Our Gallery",
    paymentTitle: "Easy Payment",
    paymentSub: "Secure payment in multiple currencies",
    payCard: "Credit/Debit Card",
    payPix: "Pix",
    payCash: "Cash (BRL, USD, EUR)",
    payOnline: "PayPal / Stripe",
    ctaTitle: "Ready to Travel in Comfort?",
    ctaSub:
      "Request your quote now via WhatsApp and receive a response within minutes.",
    ctaBtn: "Chat on WhatsApp",
    footerLinks: "Quick Links",
    footerContact: "Contact",
    footerCopy: "© 2026 Rio Executive Transfer. All rights reserved.",
    navRoutes: "Routes",
    navVehicles: "Vehicles",
    navGallery: "Gallery",
    navContact: "Contact",
    footerDesc:
      "Executive Transport in Rio de Janeiro. Comfort, safety and punctuality in every detail.",
    transportExec: "Executive Transport",
    transportExecDesc: "Comfort and safety in every detail.",
    tourism: "Personalized Tourism",
    tourismDesc: "Exclusive itineraries your way.",
    transfers: "Transfers",
    transfersDesc: "Airports, hotels, events and more.",
    cadastur: "Registered with Cadastur",
    cadasturDesc: "Legal and safe tourism.",
    schedule:
      "Schedule your time and live unique experiences in Rio de Janeiro.",
    // Form translations
    formTitle: "Request a Free Quote",
    formOrigin: "Origin",
    formDestination: "Destination",
    formDate: "Date",
    formTime: "Time",
    formPassengers: "Passengers",
    formBaggage: "Baggage",
    formNameOrFlight: "Flight number (optional)",
    formChildSeat: "Need a child seat?",
    formWifi: "Need WiFi in the car?",
    formSubmit: "Request Free Quote",
    formPlaceholderOrigin: "Select origin",
    formPlaceholderDest: "Ex: Copacabana",
    formPlaceholderName: "Ex: LA4500",
    originGaleao: "Galeão Airport",
    originSantosDumont: "Santos Dumont Airport",
    originOther: "Other address",
    // City Tour
    cityToursTitle: "City Tours in Rio",
    tourClassic: "Classic City Tour",
    tourComplete: "Complete City Tour",
    tourHistoric: "Historic City Tour",
    tourNature: "Nature City Tour",
    tourBeaches: "Beaches City Tour",
    tourCultural: "Cultural City Tour",
    tourCustom: "Custom City Tour",
    tourCustomDesc:
      "Build your exclusive itinerary according to your preferences",
    clickToReturn: "Click to return",
    cityTourLabel: "CITY TOUR",
    tourCustomCta: "BUILD YOUR ITINERARY",
    tourCustomMsg: "Hello! I would like to build a custom City Tour.",
    itemCristo: "Christ the Redeemer",
    itemPaoAcucar: "Sugarloaf Mountain",
    itemEscadaria: "Selarón Steps",
    itemArcosLapa: "Lapa Arches",
    itemMaracana: "Maracanã (external area)",
    itemCatedral: "Metropolitan Cathedral",
    itemMiranteDonaMarta: "Dona Marta Viewpoint",
    itemPracaXV: "XV Square",
    itemPacoImperial: "Imperial Palace",
    itemRealGabinete: "Royal Portuguese Reading Room",
    itemConfeitariaColombo: "Colombo Confectionery",
    itemTheatroMunicipal: "Municipal Theatre of Rio de Janeiro",
    itemJardimBotanico: "Rio de Janeiro Botanical Garden",
    itemParqueLage: "Lage Park",
    itemFlorestaTijuca: "Tijuca Forest",
    itemPraiaCopacabana: "Copacabana Beach",
    itemPraiaIpanema: "Ipanema Beach",
    itemArpoador: "Arpoador",
    itemLeblon: "Leblon",
    itemSaoConrado: "São Conrado",
    itemMuseuAmanha: "Museum of Tomorrow",
    itemMuseuArteRio: "Rio Art Museum",
    itemAquario: "AquaRio",
    itemBoulevardOlimpico: "Olympic Boulevard",
    // Destinations
    destinosTitle: "Destinations",
    destinoLagosTitle: "Lakes Region",
    destinoLagosSubtitle: "Paradisiacal beaches and crystal-clear waters.",
    destinoCostaVerdeTitle: "Green Coast",
    destinoCostaVerdeSubtitle: "Lush nature and stunning sea.",
    destinoSerranaTitle: "Mountain Region",
    destinoSerranaSubtitle: "Mild climate, mountains and lots of tranquility.",
    destinoSaoPauloTitle: "São Paulo",
    destinoSaoPauloSubtitle: "Vibrant metropolis and incredible destinations.",
    destinoEspiritoSantoTitle: "Espírito Santo",
    destinoEspiritoSantoSubtitle: "Natural beauty and beaches for all tastes.",
    destinoMinasGeraisTitle: "Minas Gerais",
    destinoMinasGeraisSubtitle: "History, culture and enchanting landscapes.",
    destinoOceanicaTitle: "Niterói Oceanic Region",
    destinoOceanicaSubtitle: "Amazing beaches close to you.",
    destinoNiteroiTitle: "Niterói",
    destinoNiteroiSubtitle: "Urban beaches and quality of life every day.",
  },
  "es-ES": {
    badge: "Transporte Ejecutivo en Río de Janeiro",
    heroTitle: "Transfer Premium en Río de Janeiro",
    heroSubtitle:
      "Del Aeropuerto a Su Destino con Seguridad, Confort y Puntualidad",
    heroCta: "Solicitar Cotización",
    heroCtaForm: "Solicitar cotización",
    heroSecondary: "Ver Destinos",
    featuresTitle: "Por Qué Elegir a Rio Executive Transfer",
    featPrice: "Precio Justo",
    featPriceDesc: "Tarifas competitivas sin sorpresas",
    featSafety: "Seguridad Garantizada",
    featSafetyDesc: "Conductores experimentados y vehículos inspeccionados",
    featPunctual: "Puntualidad",
    featPunctualDesc: "Monitoreo de vuelos en tiempo real",
    featFleet: "Flota Variada",
    featFleetDesc: "Sedán, SUV y vehículos especiales",
    featExtras: "Extras Incluidos",
    featExtrasDesc: "Servicio personalizado y silla de niño",
    feat24h: "Servicio 24h",
    feat24hDesc: "Disponible todos los días del año",
    routesTitle: "Rutas Más Populares",
    routeConsult: "Consultar precios",
    routeAll: "Ver todas las rutas",
    howTitle: "Simple y Rápido",
    step1Title: "Solicita tu Cotización",
    step1Desc: "Completa el formulario o contáctanos por WhatsApp",
    step2Title: "Recibe Confirmación",
    step2Desc: "Respuesta rápida con precio y detalles del viaje",
    step3Title: "Tu Conductor te Espera",
    step3Desc: "Con cartel personalizado en el aeropuerto o dirección",
    vehiclesTitle: "Vehículos Cómodos",
    vehicleExec: "Ejecutivo",
    vehicleExecPremium: "Ejecutivo Premium",
    vehicleSuv: "SUV",
    vehicleColetivos: "Colectivos",
    vehicleBlindados: "Blindados",
    execPass: "4 pasajeros + equipaje de mano",
    execPremiumPass: "4 pasajeros + equipaje de mano",
    suvPass: "4 pasajeros + equipaje de mano",
    coletivosPass: "De 12 a 46 pasajeros",
    blindadosPass: "4 pasajeros + equipaje de mano",
    vehicleMinivan: "Minivan",
    minivanPass: "5 a 8 pasajeros + equipaje de mano",
    featAc: "Carros nuevos",
    featPunctual2: "Vehículos cómodos",
    featPersonal: "Conductores experimentados",
    testiTitle: "Lo Que Dicen Nuestros Clientes",
    galleryTitle: "Nuestra Galería",
    paymentTitle: "Pago Facilitado",
    paymentSub: "Pago seguro en múltiples monedas",
    payCard: "Tarjeta de Crédito/Débito",
    payPix: "Pix",
    payCash: "Efectivo (Real, Dólar, Euro)",
    payOnline: "PayPal / Stripe",
    ctaTitle: "¿Listo para Viajar con Comodidad?",
    ctaSub:
      "Solicita tu cotización ahora por WhatsApp y recibe atención en minutos.",
    ctaBtn: "Escribir por WhatsApp",
    footerLinks: "Enlaces Rápidos",
    footerContact: "Contacto",
    footerCopy: "© 2026 Rio Executive Transfer. Todos los derechos reservados.",
    navRoutes: "Rutas",
    navVehicles: "Vehículos",
    navGallery: "Galería",
    navContact: "Contacto",
    footerDesc:
      "Transporte Ejecutivo en Río de Janeiro. Confort, seguridad y puntualidad en cada detalle.",
    transportExec: "Transporte Ejecutivo",
    transportExecDesc: "Confort y seguridad en cada detalle.",
    tourism: "Turismo Personalizado",
    tourismDesc: "Itinerarios exclusivos a tu manera.",
    transfers: "Traslados",
    transfersDesc: "Aeropuertos, hoteles, eventos y mucho más.",
    cadastur: "Registrado en Cadastur",
    cadasturDesc: "Turismo legal y seguro.",
    schedule: "Agenda tu horario y vive experiencias únicas en Río de Janeiro.",
    // Form translations
    formTitle: "Solicitar Cotización Gratis",
    formOrigin: "Origen",
    formDestination: "Destino",
    formDate: "Fecha",
    formTime: "Hora",
    formPassengers: "Pasajeros",
    formBaggage: "Equipaje",
    formNameOrFlight: "Número de vuelo (opcional)",
    formChildSeat: "¿Necesita silla de niño?",
    formWifi: "¿Necesita WiFi en el coche?",
    formSubmit: "Solicitar Cotización Gratis",
    formPlaceholderOrigin: "Seleccione el origen",
    formPlaceholderDest: "Ej: Copacabana",
    formPlaceholderName: "Ej: LA4500",
    originGaleao: "Aeropuerto Galeão",
    originSantosDumont: "Aeropuerto Santos Dumont",
    originOther: "Otra dirección",
    // City Tour
    cityToursTitle: "City Tours en Río",
    tourClassic: "City Tour Clásico",
    tourComplete: "City Tour Completo",
    tourHistoric: "City Tour Histórico",
    tourNature: "City Tour Naturaleza",
    tourBeaches: "City Tour Playas",
    tourCultural: "City Tour Cultural",
    tourCustom: "City Tour Personalizado",
    tourCustomDesc:
      "Arma tu itinerario exclusivo de acuerdo con tus preferencias",
    clickToReturn: "Toca para volver",
    cityTourLabel: "CITY TOUR",
    tourCustomCta: "ARMA TU ITINERARIO",
    tourCustomMsg: "¡Hola! Me gustaría armar un City Tour personalizado.",
    itemCristo: "Cristo Redentor",
    itemPaoAcucar: "Pan de Azúcar",
    itemEscadaria: "Escalera Selarón",
    itemArcosLapa: "Arcos de Lapa",
    itemMaracana: "Maracanã (zona externa)",
    itemCatedral: "Catedral Metropolitana",
    itemMiranteDonaMarta: "Mirador Dona Marta",
    itemPracaXV: "Plaza XV",
    itemPacoImperial: "Palacio Imperial",
    itemRealGabinete: "Real Gabinete Portugués de Lectura",
    itemConfeitariaColombo: "Confitería Colombo",
    itemTheatroMunicipal: "Teatro Municipal de Río de Janeiro",
    itemJardimBotanico: "Jardín Botánico de Río de Janeiro",
    itemParqueLage: "Parque Lage",
    itemFlorestaTijuca: "Bosque de Tijuca",
    itemPraiaCopacabana: "Playa de Copacabana",
    itemPraiaIpanema: "Playa de Ipanema",
    itemArpoador: "Arpoador",
    itemLeblon: "Leblon",
    itemSaoConrado: "São Conrado",
    itemMuseuAmanha: "Museo del Mañana",
    itemMuseuArteRio: "Museo de Arte de Río",
    itemAquario: "AquaRio",
    itemBoulevardOlimpico: "Bulevar Olímpico",
    // Destinos
    destinosTitle: "Destinos",
    destinoLagosTitle: "Región de los Lagos",
    destinoLagosSubtitle: "Playas paradisíacas y aguas cristalinas.",
    destinoCostaVerdeTitle: "Costa Verde",
    destinoCostaVerdeSubtitle: "Naturaleza exuberante y mar deslumbrante.",
    destinoSerranaTitle: "Región Serrana",
    destinoSerranaSubtitle: "Clima ameno, montañas y mucha tranquilidad.",
    destinoSaoPauloTitle: "São Paulo",
    destinoSaoPauloSubtitle: "Metrópoli vibrante y destinos increíbles.",
    destinoEspiritoSantoTitle: "Espírito Santo",
    destinoEspiritoSantoSubtitle:
      "Bellezas naturales y playas para todos los estilos.",
    destinoMinasGeraisTitle: "Minas Gerais",
    destinoMinasGeraisSubtitle: "Historia, cultura y paisajes que encantan.",
    destinoOceanicaTitle: "Región Oceánica de Niterói",
    destinoOceanicaSubtitle: "Playas increíbles cerca de ti.",
    destinoNiteroiTitle: "Niterói",
    destinoNiteroiSubtitle: "Playas urbanas y calidad de vida todos los días.",
  },
};

function useLang() {
  return useContext(LangContext);
}

// ========== LOGO COMPONENT ==========
const Logo = ({ className = "" }) => (
  <div className={`logo-wrap ${className}`}>
    <svg
      viewBox="0 0 203 48"
      className="logo-svg"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Instagram gradient — used by footer Instagram icon */}
        <linearGradient
          id="instagram-gradient"
          x1="0%"
          y1="100%"
          x2="100%"
          y2="0%"
        >
          <stop offset="0%" stopColor="#f09433" />
          <stop offset="25%" stopColor="#e6683c" />
          <stop offset="50%" stopColor="#dc2743" />
          <stop offset="75%" stopColor="#cc2366" />
          <stop offset="100%" stopColor="#bc1888" />
        </linearGradient>
      </defs>
      <path d="m101.7 3.1c0.5 0.1 1 0.5 1.2 0.7 0.3 0.5 0.3 0.7 0.4 13.1v12.5l-0.4 0.6c-0.3 0.4-0.6 0.7-1.2 0.9-0.9 0.3-0.9 0.3 3.3 0.3 2.4-0.1 4-0.1 3.7-0.2-0.8-0.2-1.2-0.5-1.5-1.1-0.3-0.5-0.4-1.2-0.4-6.2l-0.1-5.6h2.6c2.2 0.1 2.6 0.1 3.2 0.5 1.5 0.7 2.4 1.7 4.9 5.3 2.7 3.9 4 5.1 6.3 6.3 1.9 0.9 3 1.2 5.7 1.2l2.4 0.1-1.2-0.2c-1.6-0.3-2-0.5-3.6-1.4-1.4-0.8-3.1-2.4-4.8-4.8-3.5-4.7-4.4-5.6-6.3-6.6l-1.2-0.6 1.2-0.1c5.3-0.5 8.9-3.4 9.1-7.3 0.2-3.8-2.2-6.5-6.8-7.4-1.4-0.3-2.3-0.3-9.5-0.3-7.6 0-7.9 0-7 0.3zm14.4 0.3c2 0.4 3.8 1.8 4.7 3.6 0.4 0.8 0.5 1.4 0.6 2.6 0.2 3.7-1.6 6.3-5.2 7.5-0.8 0.3-1.5 0.4-5.2 0.4l-4.2 0.1v-6.5c0-6.5 0-7.1 0.6-7.6 0.4-0.3 7.3-0.3 8.7-0.1z" />
      <path d="m144.9 3.1c0.6 0.2 1 0.4 1.3 0.8l0.4 0.6v7.9c0 12.9 0 16.9-0.3 17.4-0.3 0.7-0.8 1-1.7 1.2-0.5 0.1 0.7 0.1 3.6 0.1 4.3 0.1 4.3 0.1 3.4-0.2-0.6-0.3-0.9-0.5-1.2-0.9-0.3-0.6-0.3-0.9-0.4-12.8 0-10.8 0-12.2 0.3-12.9 0.3-0.7 0.6-1 1.7-1.3 0.6-0.2-0.1-0.2-3.6-0.2-4.3 0-4.3 0-3.5 0.3z" />
      <path d="m181.9 2.5c-4.4 0.8-8.5 3.3-10.7 6.6-1 1.4-1.5 2.6-2 4.3-0.6 2-0.6 4.9-0.1 7 1.8 6.8 8.3 11.3 16.3 11.3 10.1 0 17.5-7.2 16.6-16.1-0.7-7.8-7.8-13.4-16.7-13.3-1.2 0-2.7 0.1-3.4 0.2zm5.3 0.3c5.4 0.7 9.5 4.8 10.8 10.9 0.3 1.5 0.3 5 0 6.6-1 5.2-4.6 9.3-9.2 10.6-1.9 0.5-5 0.5-6.8 0-4.1-1.2-7.3-4.3-8.7-8.7-1.4-4.1-1.1-8.5 0.9-12.5 0.9-1.7 1.2-2.2 2.4-3.4 2.8-2.9 6.5-4.1 10.6-3.5z" />
      <path
        fill-rule="evenodd"
        d="m65.7 0.6c0 0.2 0.1 0.5 0.1 0.5 0.1 0.2 1.6 0.5 2.3 0.4 0.4-0.1 0.8 0 0.8 0 0.3 0.2 0.1 0.3-0.3 0.3-0.3 0-0.4 0.1-0.6 0.4-0.1 0.2-0.2 0.3-0.6 0.3-0.3 0-0.6 0-0.8 0.1l-0.4 0.1v1.4c0 2.7 0 2.6 0.2 2.9 0.2 0.1 0.3 0.3 0.3 0.4 0 0.1 0.1 0.2 0.3 0.2 1.3 0.3 2.1 0.8 3.2 1.9 1 1 1.5 1.8 2.6 4.4 1.3 2.8 2.1 3.9 2.9 4.5 0.3 0.2 1.1 0.6 1.9 0.8 1.7 0.6 2.8 1.1 4.1 2.2 2 1.6 3.6 3.8 6.3 8.3 2.9 5.1 4.6 7.6 6.3 9.7 0.8 0.9 2.1 2.2 2.7 2.7 0.7 0.5 0.4 0.4-0.5-0.1q-2.7-1.6-5.3-5c-1.3-1.7-1.4-1.8-5-7.7-3.3-5.3-6-7.8-9.2-8.7-1.7-0.5-2.6-1.1-3.6-2.6-0.3-0.4-1.1-1.9-1.7-3.4-1.8-3.6-2.4-4.4-4.1-5.2-0.7-0.3-0.9-0.4-1.8-0.4-2.5-0.1-3.7 0.8-5.7 4.4-2.2 4.1-3.6 6.2-5.6 8.2-1.6 1.6-2.7 2.3-4.3 2.7-1.3 0.3-2.5 0.6-3.6 1.1-2 0.8-3.3 1.6-6.7 4.1-3.4 2.6-4.9 3.5-6.9 4.2-1.4 0.5-2.8 0.7-6.2 1.1-10.3 1.1-15.4 2.3-23.1 5.5-1 0.4-2.1 0.9-2.3 1-0.9 0.5-0.2-0.1 1.2-0.9 3.4-1.9 6.8-3.4 10.2-4.4 0.9-0.3 1.6-0.5 1.7-0.6 0.1-0.1 0.2-0.7 0.3-1.4 0.4-2.6 1.6-6.6 2.7-9 2.5-5.8 5.7-9.4 9-10.1 2.6-0.6 5 1.3 7.4 5.9 0.8 1.6 1.4 3 2.7 6.3 0.5 1.3 1 2.5 1.1 2.5 0 0 0.4-0.3 2.6-2 3.3-2.5 5.4-3.5 9.1-4.5 1.9-0.5 2.3-0.7 3.3-1.6 1.9-1.7 3.8-4.4 5.5-7.6 1.6-3 2-3.6 2.8-4.5 0.6-0.7 1.6-1.3 2.4-1.6q0.6-0.2 0.6-0.3c0-0.2 0.1-0.3 0.2-0.4 0.2-0.2 0.2-0.3 0.2-1.2 0-1.5-0.2-3.1-0.4-3.3-0.1 0-0.4-0.1-0.7-0.1-0.4 0-0.9-0.3-0.9-0.5 0-0.1-0.1-0.2-0.3-0.2-0.4 0-0.6-0.1-0.5-0.3 0.1 0 0.4 0 0.8 0 0.7 0 2.1-0.2 2.3-0.3 0.1-0.1 0.2-0.3 0.1-0.5 0-0.2 0.1-0.4 0.2-0.5 0.4-0.4 0.7-0.2 0.7 0.4zm-37.5 16c-0.3-0.1-0.3-0.1-0.5 0.2-0.7 1.1-1.3 4.1-2.1 9.9 0 0.4-0.1-0.2-0.1-2.5 0-3.3 0.1-5.2 0.5-6.7 0.1-0.4 0.1-0.8 0.1-0.8-0.1-0.1-1.6 0.8-2.4 1.5-2.4 2.1-4.6 5.4-6.7 10.2-0.8 1.9-2.4 6.8-2.2 7 0 0 0.4-0.1 0.8-0.2 2.6-0.6 5.9-1.1 11.9-1.7 3.6-0.4 4.8-0.7 6.8-1.7 0.7-0.4 2.7-1.6 3.1-2 0 0-0.1-0.3-0.4-0.7-0.7-1.2-0.9-1.7-1.7-3.2-1.3-2.4-2.7-4.9-3.5-6.1-0.9-1.2-2.3-2.7-2.9-3-0.2-0.1-0.5-0.2-0.7-0.2z"
      />
      <path
        fill-rule="evenodd"
        d="m53.2 31.4c-4.5 0.3-7.8 0.8-9.8 1.5-1.4 0.5-4.5 2.3-7.6 4.4-0.4 0.3-0.7 0.4-1.1 0.5-8.1 1-13.7 2.4-16.3 4.1-0.9 0.6-1.1 0.8-1 1.7 0 0.8 0 0.8-0.3 1q-0.8 0.5-0.7 1.7c0.2 1.3 0.5 1.9 0.5 0.8 0-0.3 0.1-0.7 0.2-1 0.1-0.9 0.6-1.1 1.3-0.8 0.6 0.3 1.9 0.4 4.3 0.4 2.5 0 4.1-0.1 4.5-0.4 0.5-0.2 1.8-2.2 1.6-2.4 0 0-5.5-0.1-9.1-0.1h-1.3l0.4-0.3c1.8-1.3 7.5-2.9 14.1-3.8 4-0.5 8.8-0.8 14.6-1 3 0 3.3 0 3.8-0.3 0.3-0.1 1.2-0.8 2.5-2.1 2-2 2.7-2.5 3.7-2.9 1.6-0.6 5-0.5 8.7 0.5 3.5 0.9 5.9 2.1 8.9 4.5 0.7 0.5 1.3 1 1.4 1.1 0 0-0.1 0.1-0.2 0.2q-0.7 0.2 0.3 0.4c0.4 0 1.2 0.1 1.9 0.3 2.3 0.5 3.6 1.4 4.5 3.1q0.8 1.5 0.3-0.3c-0.4-2.2-1.6-3.2-4.4-4.1-1.5-0.4-2.3-0.8-4-2-3.8-2.6-7.3-3.9-12.2-4.5-1.7-0.2-7.1-0.3-9.5-0.2z"
      />
      <path
        fill-rule="evenodd"
        d="m59.9 32.8c-1.8 0.2-2.8 0.8-4.4 2.6-1.2 1.2-2.6 3-2.6 3.2 0 0.1 0.2 0.1 1.2 0 0.7 0 1.3-0.1 1.3-0.1 0 0-0.1-0.1-0.2-0.2-0.4-0.6 0.4-1.8 1.4-2 1.1-0.3 2.9 0.1 3.1 0.5 0.1 0.2 0.1 0.4 0.1 0.5 0 0.4-0.5 0.6-1.7 0.9-1.1 0.2-1.4 0.4-0.6 0.3 0.3 0 4.1-0.1 8.5-0.2 4.4 0 7.9-0.1 7.9-0.1 0 0-0.1-0.3-0.4-0.6-0.9-1.3-3.1-2.7-5.5-3.6-2.5-0.8-5.8-1.3-8.1-1.2z"
      />
      <path
        fill-rule="evenodd"
        d="m38.1 41.9c-2.2 0.2-5.4 0.7-6.1 0.8-0.5 0.1-0.9 0.3-1 0.4-0.5 0.5-1.3 1.7-1.2 1.9 0 0.1 0.3 0.3 0.7 0.4 0.5 0.1 0.9 0.1 2.6 0.1 3.8-0.2 5-0.6 6.5-2.7 0.4-0.5 0.7-1 0.7-1 0-0.1-0.6-0.1-2.2 0.1z"
      />
      <path
        fill-rule="evenodd"
        d="m45.4 41.9c-1.1 0.3-2.6 1.5-3.2 2.6-0.4 0.6-0.8 1.7-0.7 1.6 0.1 0 0.3-0.3 0.6-0.6 0.6-0.9 1.8-1.8 2.8-2.1 2.3-0.7 4.5 0.3 5.8 2.6l0.4 0.6-0.1-0.6c-0.2-1.6-1.2-3.1-2.6-3.8-0.6-0.2-0.9-0.3-1.7-0.3-0.5-0.1-1.1 0-1.3 0z"
      />
      <path
        fill-rule="evenodd"
        d="m129 38.1c0.1 0.2 1.2 0.2 21.9 0.2 20.7 0 21.8 0 21.8-0.2 0.1-0.2-1-0.2-21.8-0.2-20.8 0-21.9 0-21.9 0.2z"
      />
      <path
        fill-rule="evenodd"
        d="m120.9 42.1c-1.5 0.4-2 2.7-0.7 3.7 0.7 0.5 1.9 0.4 2.5-0.1 0.4-0.4 0.4-0.6 0.1-0.7-0.2-0.1-0.4-0.1-0.6 0.1-0.5 0.4-1.1 0.4-1.5 0-0.3-0.3-0.4-0.5-0.4-1 0-0.5 0.1-0.6 0.4-0.9 0.4-0.5 1-0.5 1.4-0.1 0.4 0.2 0.5 0.2 0.7 0 0.7-0.4-0.8-1.2-1.9-1z"
      />
      <path
        fill-rule="evenodd"
        d="m182.8 42.1c-0.6 0.2-0.9 0.7-0.9 1.2 0 0.4 0.1 0.6 0.5 0.8 0.2 0.1 0.6 0.3 0.8 0.3 0.3 0.1 0.6 0.2 0.7 0.3 0.6 0.5-0.5 1-1.2 0.5-0.4-0.3-0.4-0.3-0.7-0.1q-0.4 0.3 0.3 0.8c0.8 0.4 2.2 0.2 2.5-0.4 0.2-0.3 0.2-1 0-1.2-0.2-0.3-1.1-0.7-1.5-0.7-0.3 0-0.6-0.3-0.5-0.5 0-0.2 0.1-0.3 0.5-0.3 0.3 0 0.6 0.1 0.7 0.2 0.2 0.2 0.3 0.2 0.5 0.1q0.3-0.1 0.3-0.3c0-0.2-0.5-0.6-0.9-0.7-0.5-0.1-0.6-0.1-1.1 0z"
      />
      <path
        fill-rule="evenodd"
        d="m102.3 44.1v2h1.4 1.4v-0.3-0.4h-1l-0.9-0.1-0.1-0.4v-0.4h0.9 0.9v-0.4-0.3l-0.9-0.1h-0.8l-0.1-0.4v-0.5h1 1v-0.3-0.4h-1.4-1.4z"
      />
      <path
        fill-rule="evenodd"
        d="m107.9 42.4c0.1 0.1 0.4 0.5 0.6 0.9 0.3 0.3 0.5 0.7 0.5 0.7 0 0.1-0.2 0.4-0.4 0.6-0.2 0.3-0.5 0.7-0.6 1l-0.3 0.5h0.5c0.4 0 0.5 0 0.9-0.6 0.2-0.4 0.4-0.7 0.4-0.7 0.1 0 0.3 0.3 0.6 0.7 0.3 0.5 0.4 0.6 0.8 0.6 0.2 0 0.4 0 0.4-0.1 0 0-0.3-0.5-0.6-1-0.3-0.4-0.6-0.9-0.6-0.9 0-0.1 0.2-0.4 0.5-0.8 0.2-0.4 0.5-0.8 0.6-0.9 0.1-0.3 0.1-0.3-0.4-0.3-0.4 0-0.4 0.1-0.8 0.7l-0.4 0.6-0.5-0.6c-0.4-0.6-0.4-0.7-0.9-0.7-0.4 0-0.4 0-0.3 0.3z"
      />
      <path
        fill-rule="evenodd"
        d="m114.1 44c0 1 0 1.9 0 2 0 0 0.6 0.1 1.4 0.1 1.2 0 1.3 0 1.3-0.2 0.1-0.4 0-0.5-1-0.5l-0.9-0.1v-0.4-0.4h0.9l0.9-0.1v-0.3-0.3h-0.9c-0.9 0-1.1-0.1-0.9-0.7 0.1-0.3 0.1-0.3 1-0.3h0.9v-0.3-0.4h-1.3-1.4z"
      />
      <path
        fill-rule="evenodd"
        d="m125.9 43.7v1.6l0.4 0.3c0.4 0.5 1 0.6 1.7 0.5 1-0.3 1.3-0.8 1.3-2.6v-1.4h-0.5-0.4v1.3c0 1.7-0.1 2-0.8 2-0.8 0-0.9-0.3-0.9-2v-1.3h-0.4-0.5z"
      />
      <path
        fill-rule="evenodd"
        d="m132 42.5c0 0.3 0 0.3 0.5 0.3h0.6v1.7 1.6h0.4 0.4v-1.6-1.7h0.6c0.6 0 0.6 0 0.6-0.3v-0.4h-1.6-1.5z"
      />
      <path
        fill-rule="evenodd"
        d="m137.9 44.1v2h0.4l0.4-0.1v-1.9l0.1-2h-0.5-0.4z"
      />
      <path
        fill-rule="evenodd"
        d="m141.4 42.2c0 0 0.3 1 0.7 2l0.7 1.9h0.5l0.5-0.1 0.7-1.8c0.4-1.1 0.7-2 0.7-2 0-0.1-0.2-0.1-0.4-0.1l-0.5 0.1-0.5 1.4c-0.2 0.7-0.5 1.3-0.5 1.3 0 0-0.1-0.2-0.2-0.4-0.1-0.3-0.3-0.9-0.5-1.4-0.4-1-0.4-1-0.8-1-0.2 0-0.4 0.1-0.4 0.1z"
      />
      <path
        fill-rule="evenodd"
        d="m147.9 44.1v2h1.4 1.4v-0.3-0.4h-1l-0.9-0.1-0.1-0.4v-0.4h0.9 0.9v-0.4-0.3l-0.9-0.1h-0.8v-0.4-0.4l0.9-0.1h1v-0.3-0.4h-1.4-1.4z"
      />
      <path
        fill-rule="evenodd"
        d="m157.3 42.5c0 0.3 0 0.3 0.6 0.3h0.5v1.7 1.6h0.4 0.5v-1.6-1.7h0.6c0.5 0 0.5 0 0.5-0.3v-0.3l-1.6-0.1h-1.5z"
      />
      <path
        fill-rule="evenodd"
        d="m163.1 42.1h1.1c1.6 0 2 0.3 2 1.3 0 0.5-0.1 0.6-0.4 0.9l-0.3 0.4 0.4 0.7 0.4 0.6-0.4 0.1c-0.5 0-0.6 0-1-0.7-0.2-0.6-0.2-0.7-0.6-0.7h-0.4v1.4h-0.8zm0.9 0.9c0 0.1-0.1 0.3 0 0.5 0 0.4 0 0.4 0.5 0.4 0.3 0.1 0.5 0 0.7-0.1 0.2-0.3 0.2-0.7-0.1-0.9-0.3-0.2-1-0.1-1.1 0.1z"
      />
      <path
        fill-rule="evenodd"
        d="m170.3 42.1h1l0.3 0.8c0.2 0.4 0.5 1.3 0.7 1.9 0.3 0.6 0.5 1.1 0.5 1.2 0 0-0.2 0.1-0.5 0.1-0.3 0-0.4-0.1-0.5-0.4l-0.2-0.4h-1.6l-0.2 0.4c-0.1 0.3-0.2 0.4-0.5 0.4-0.2 0-0.4-0.1-0.4-0.1 0-0.1 0.3-1 0.7-2zm0.5 0.9c0 0-0.1 0.3-0.3 0.6-0.1 0.4-0.2 0.7-0.2 0.8 0 0.1 0.1 0.1 0.5 0.1 0.4 0 0.5 0 0.5-0.1 0-0.1-0.1-0.4-0.3-0.8-0.1-0.3-0.2-0.6-0.2-0.6z"
      />
      <path
        fill-rule="evenodd"
        d="m175.5 44.1v1.9l0.4 0.1h0.4v-1.2c0-0.7 0-1.3 0.1-1.3 0 0 0.4 0.6 0.9 1.3 0.8 1.1 0.9 1.2 1.3 1.2h0.4v-2-2h-0.4-0.4l-0.1 1.3v1.2l-0.9-1.2c-0.9-1.2-0.9-1.3-1.3-1.3h-0.5z"
      />
      <path
        fill-rule="evenodd"
        d="m187.8 44.1v2h0.4 0.4v-0.8-0.8h0.9 1l-0.1-0.4c0-0.3 0-0.3-0.9-0.3l-0.9-0.1v-0.4-0.5h1 1l-0.1-0.3v-0.3l-1.4-0.1h-1.3z"
      />
      <path
        fill-rule="evenodd"
        d="m193.3 42.2c0 0 0 0.9 0 2v1.9h1.4c0.7 0 1.4 0 1.4-0.1 0 0 0-0.2 0-0.3-0.1-0.3-0.1-0.3-1-0.3h-0.9v-0.5-0.4l0.9-0.1c0.8 0 0.8 0 0.8-0.3l0.1-0.3-0.9-0.1h-1v-0.4-0.4l1-0.1h1v-0.3-0.4h-1.4c-0.7 0-1.3 0-1.4 0.1z"
      />
      <path
        fill-rule="evenodd"
        d="m199 42.1h1.1c1.6 0 2.1 0.3 2.1 1.2q0 0.8-0.5 1.2c-0.3 0.2-0.3 0.2 0.1 0.8 0.2 0.3 0.4 0.6 0.4 0.7 0 0-0.2 0.1-0.4 0.1-0.4 0-0.5-0.1-0.8-0.7-0.4-0.5-0.5-0.7-0.8-0.7h-0.4v1.4h-0.8zm1.4 0.7h-0.6l0.1 1.1h0.5c0.8 0.1 1.2-0.4 0.8-0.9q-0.2-0.2-0.8-0.2z"
      />
    </svg>
  </div>
);

// ========== ICONS ==========
const ShieldIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const ClockIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const CarIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a1 1 0 0 0-.8-.4H5.24a2 2 0 0 0-1.8 1.1l-.8 1.63A6 6 0 0 0 2 12.42V16h2" />
    <circle cx="6.5" cy="16.5" r="2.5" />
    <circle cx="16.5" cy="16.5" r="2.5" />
  </svg>
);

const StarIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const BabyIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 12h.01" />
    <path d="M15 12h.01" />
    <path d="M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5" />
    <path d="M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1" />
  </svg>
);

const PhoneIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const DollarIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

const ChevronRight = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const CreditCardIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);

const PixIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="100"
    height="100"
    viewBox="0 0 50 50"
    fill="currentColor"
  >
    <path d="M 25 0.0390625 C 22.84 0.0390625 20.799531 0.88015625 19.269531 2.4101562 L 9.6796875 12 L 12.929688 12 C 14.529687 12 16.039922 12.619766 17.169922 13.759766 L 23.939453 20.529297 C 24.519453 21.109297 25.480547 21.109531 26.060547 20.519531 L 32.830078 13.759766 C 33.960078 12.619766 35.470312 12 37.070312 12 L 40.320312 12 L 30.730469 2.4101562 C 29.200469 0.88015625 27.16 0.0390625 25 0.0390625 z M 7.6796875 14 L 2.4101562 19.269531 C -0.74984375 22.429531 -0.74984375 27.570469 2.4101562 30.730469 L 7.6796875 36 L 12.929688 36 C 13.999687 36 14.999766 35.580078 15.759766 34.830078 L 22.529297 28.060547 C 23.889297 26.700547 26.110703 26.700547 27.470703 28.060547 L 34.240234 34.830078 C 35.000234 35.580078 36.000312 36 37.070312 36 L 42.320312 36 L 47.589844 30.730469 C 50.749844 27.570469 50.749844 22.429531 47.589844 19.269531 L 42.320312 14 L 37.070312 14 C 36.000313 14 35.000234 14.419922 34.240234 15.169922 L 27.470703 21.939453 C 26.790703 22.619453 25.9 22.960938 25 22.960938 C 24.1 22.960937 23.209297 22.619453 22.529297 21.939453 L 15.759766 15.169922 C 14.999766 14.419922 13.999688 14 12.929688 14 L 7.6796875 14 z M 25 29.037109 C 24.615 29.038359 24.229453 29.185469 23.939453 29.480469 L 17.169922 36.240234 C 16.039922 37.380234 14.529687 38 12.929688 38 L 9.6796875 38 L 19.269531 47.589844 C 20.799531 49.119844 22.84 49.960938 25 49.960938 C 27.16 49.960938 29.200469 49.119844 30.730469 47.589844 L 40.320312 38 L 37.070312 38 C 35.470313 38 33.960078 37.380234 32.830078 36.240234 L 26.060547 29.470703 C 25.770547 29.180703 25.385 29.035859 25 29.037109 z"></path>
  </svg>
);

const MoneyIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="6" width="20" height="12" rx="2" />
    <circle cx="12" cy="12" r="2" />
    <path d="M6 12h.01M18 12h.01" />
  </svg>
);

const GlobeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

const CalendarIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const CheckIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const InstagramIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

const ColumnIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 22h16" />
    <path d="M6 18V2h3v16" />
    <path d="M15 18V2h3v16" />
  </svg>
);

const CameraTourIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
    <circle cx="12" cy="13" r="4" />
  </svg>
);

const BuildingIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 21h18" />
    <path d="M5 21V7l8-4 8 4v14" />
    <path d="M9 21v-6h6v6" />
  </svg>
);

const LeafIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11 20A7 7 0 0 1 9.8 6.6C13.4 4.2 19 3 21 3c0 2-1.2 7.6-4.8 11.4A7 7 0 0 1 11 20z" />
    <path d="M11 20v-9" />
  </svg>
);

const WavesIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" />
    <path d="M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" />
    <path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" />
  </svg>
);

const MuseumIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M2 22h20" />
    <path d="M2 6l10-4 10 4" />
    <path d="M4 6v16" />
    <path d="M20 6v16" />
    <path d="M12 6v16" />
  </svg>
);

const PalmTreeIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 22v-8" />
    <path d="M12 14c-3 0-7-2-7-7 0 0 3 2 7 2s7-2 7-2c0 5-4 7-7 7z" />
    <path d="M12 14c-2-1-4-4-3-8 0 0 2 2 3 3s3-3 3-3c1 4-1 7-3 8z" />
  </svg>
);

const MountainIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M8 18l4-8 4 8" />
    <path d="M6 22l6-12 6 12" />
    <path d="M2 22h20" />
  </svg>
);

const SunIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="5" />
    <line x1="12" y1="1" x2="12" y2="3" />
    <line x1="12" y1="21" x2="12" y2="23" />
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
    <line x1="1" y1="12" x2="3" y2="12" />
    <line x1="21" y1="12" x2="23" y2="12" />
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
  </svg>
);

const UmbrellaBeachIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 2v20" />
    <path d="M12 2a9 9 0 0 1 9 9H3a9 9 0 0 1 9-9z" />
    <path d="M12 11v9a3 3 0 0 0 3-3" />
  </svg>
);

const MailIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

// ========== DATA ==========
const getFeatures = (t) => [
  { icon: <DollarIcon />, title: t.featPrice, desc: t.featPriceDesc },
  { icon: <ShieldIcon />, title: t.featSafety, desc: t.featSafetyDesc },
  { icon: <ClockIcon />, title: t.featPunctual, desc: t.featPunctualDesc },
  { icon: <CarIcon />, title: t.featFleet, desc: t.featFleetDesc },
  { icon: <BabyIcon />, title: t.featExtras, desc: t.featExtrasDesc },
  { icon: <PhoneIcon />, title: t.feat24h, desc: t.feat24hDesc },
];

const getDestinos = (t) => [
  {
    title: t.destinoLagosTitle,
    subtitle: t.destinoLagosSubtitle,
    icon: <WavesIcon />,
    image: "/destinos/regiao-dos-lagos.jpg",
    destinations: [
      "Arraial do Cabo",
      "Cabo Frio",
      "Búzios",
      "Araruama",
      "Iguaba Grande",
      "São Pedro da Aldeia",
      "Saquarema",
      "Rio das Ostras",
      "Macaé",
    ],
  },
  {
    title: t.destinoCostaVerdeTitle,
    subtitle: t.destinoCostaVerdeSubtitle,
    icon: <PalmTreeIcon />,
    image: "/destinos/costa-verde.jpg",
    destinations: [
      "Angra dos Reis",
      "Paraty",
      "Mangaratiba",
      "Conceição de Jacareí",
      "Ilha Grande",
    ],
  },
  {
    title: t.destinoSerranaTitle,
    subtitle: t.destinoSerranaSubtitle,
    icon: <MountainIcon />,
    image: "/destinos/regiao-serrana.jpg",
    destinations: [
      "Petrópolis",
      "Teresópolis",
      "Nova Friburgo",
      "Itaipava",
      "Miguel Pereira",
      "Lumiar",
      "São Pedro da Serra",
    ],
  },
  {
    title: t.destinoSaoPauloTitle,
    subtitle: t.destinoSaoPauloSubtitle,
    icon: <BuildingIcon />,
    image: "/destinos/sao-paulo.jpg",
    destinations: [
      "São Paulo",
      "Santos",
      "Guarujá",
      "Campos do Jordão",
      "Aparecida",
      "Campinas",
      "São José dos Campos",
      "Ribeirão Preto",
    ],
  },
  {
    title: t.destinoEspiritoSantoTitle,
    subtitle: t.destinoEspiritoSantoSubtitle,
    icon: <SunIcon />,
    image: "/destinos/espirito-santo.jpg",
    destinations: [
      "Vitória",
      "Vila Velha",
      "Guarapari",
      "Marataízes",
      "Domingos Martins",
      "Pedra Azul",
    ],
  },
  {
    title: t.destinoMinasGeraisTitle,
    subtitle: t.destinoMinasGeraisSubtitle,
    icon: <MuseumIcon />,
    image: "/destinos/minas-gerais.jpg",
    destinations: [
      "Belo Horizonte",
      "Ouro Preto",
      "Tiradentes",
      "São João del-Rei",
      "Poços de Caldas",
      "Capitólio",
      "Monte Verde",
    ],
  },
  {
    title: t.destinoOceanicaTitle,
    subtitle: t.destinoOceanicaSubtitle,
    icon: <WavesIcon />,
    image: "/destinos/regiao-oceanica.jpg",
    destinations: [
      "Itacoatiara",
      "Camboinhas",
      "Itaipu",
      "Piratininga",
      "Praia do Sossego",
    ],
  },
  {
    title: t.destinoNiteroiTitle,
    subtitle: t.destinoNiteroiSubtitle,
    icon: <UmbrellaBeachIcon />,
    image: "/destinos/niteroi.jpg",
    destinations: [
      "Icaraí",
      "Boa Viagem",
      "Charitas",
      "Praia das Flechas",
      "São Francisco",
      "Gragoata",
    ],
  },
];

const getSteps = (t) => [
  { num: "1", title: t.step1Title, desc: t.step1Desc },
  { num: "2", title: t.step2Title, desc: t.step2Desc },
  { num: "3", title: t.step3Title, desc: t.step3Desc },
];

const getVehicles = (t) => [
  {
    name: t.vehicleExec,
    passengers: t.execPass,
    image: "/vehicles/onix.jpeg",
    extraImages: [
      { image: "/vehicles/cronos.png" },
      { image: "/vehicles/versa.png" },
      { image: "/vehicles/siena.png" },
    ],
    features: [t.featAc, t.featPunctual2, t.featPersonal],
  },
  {
    name: t.vehicleExecPremium,
    passengers: t.execPremiumPass,
    image: "/vehicles/corolla.jpeg",
    extraImages: [
      { image: "/vehicles/virtus.png" },
      { image: "/vehicles/civic.png" },
      { image: "/vehicles/king.png" },
    ],
    features: [t.featAc, t.featPunctual2, t.featPersonal],
  },
  {
    name: t.vehicleSuv,
    passengers: t.suvPass,
    image: "/vehicles/creta.jpeg",
    extraImages: [
      { image: "/vehicles/songplus.png" },
      { image: "/vehicles/cross.png" },
      { image: "/vehicles/kicks.png" },
    ],
    features: [t.featAc, t.featPunctual2, t.featPersonal],
  },
  {
    name: t.vehicleMinivan,
    passengers: t.minivanPass,
    image: "/vehicles/minivan.jpeg",
    extraImages: [
      { image: "/vehicles/spin.png" },
      { image: "/vehicles/doblo.png" },
      { image: "/vehicles/spin2025.jpg" },
    ],
    features: [t.featAc, t.featPunctual2, t.featPersonal],
  },
  {
    name: t.vehicleColetivos,
    passengers: t.coletivosPass,
    image: "/vehicles/vanrenault.jpeg",
    extraImages: [
      { image: "/vehicles/bus.png" },
      { image: "/vehicles/minibus.png" },
      { image: "/vehicles/sprinter.jpg" },
    ],
    features: [t.featAc, t.featPunctual2, t.featPersonal],
  },
  {
    name: t.vehicleBlindados,
    passengers: t.blindadosPass,
    image: "/vehicles/compass.jpeg",
    extraImages: [
      { image: "/vehicles/mercedes.png" },
      { image: "/vehicles/corolla.jpeg" },
      { image: "/vehicles/audi.png" },
    ],
    features: [t.featAc, t.featPunctual2, t.featPersonal],
  },
];

const getCityTours = (t) => [
  {
    title: t.tourClassic,
    items: [
      t.itemCristo,
      t.itemPaoAcucar,
      t.itemEscadaria,
      t.itemArcosLapa,
      t.itemMaracana,
    ],
  },
  {
    title: t.tourComplete,
    items: [
      t.itemCristo,
      t.itemPaoAcucar,
      t.itemEscadaria,
      t.itemCatedral,
      t.itemMaracana,
      t.itemArcosLapa,
      t.itemMiranteDonaMarta,
    ],
  },
  {
    title: t.tourHistoric,
    items: [
      t.itemPracaXV,
      t.itemPacoImperial,
      t.itemRealGabinete,
      t.itemConfeitariaColombo,
      t.itemTheatroMunicipal,
    ],
  },
  {
    title: t.tourNature,
    items: [
      t.itemJardimBotanico,
      t.itemParqueLage,
      t.itemFlorestaTijuca,
      t.itemMiranteDonaMarta,
    ],
  },
  {
    title: t.tourBeaches,
    items: [
      t.itemPraiaCopacabana,
      t.itemPraiaIpanema,
      t.itemArpoador,
      t.itemLeblon,
      t.itemSaoConrado,
    ],
  },
  {
    title: t.tourCultural,
    items: [
      t.itemMuseuAmanha,
      t.itemMuseuArteRio,
      t.itemAquario,
      t.itemBoulevardOlimpico,
    ],
  },
  {
    title: t.tourCustom,
    items: [t.tourCustomDesc],
  },
];

const getTestimonials = () => [
  {
    text: "Booked a last-minute airport pickup at 2 AM and the driver was already there with a sign. Seamless from start to finish — will use again on my next business trip.",
    name: "Michael",
    flag: "🇺🇸",
    country: "United States",
    initial: "M",
    color: "#3b5bdb",
  },
  {
    text: "Viajei com minha mãe e minha filha de 3 anos e o motorista já tinha a cadeirinha instalada. Carro impecável, ar gelado e muita paciência. Serviço de primeira!",
    name: "Ana",
    flag: "🇧🇷",
    country: "Brasil",
    initial: "A",
    color: "#2b8a3e",
  },
  {
    text: "Nous avons fait un tour panoramique au coucher du soleil — c'était magique. Le chauffeur connaissait des spots parfaits pour les photos, loin des foules. Une expérience inoubliable.",
    name: "Sophie",
    flag: "🇫🇷",
    country: "France",
    initial: "S",
    color: "#c92a2a",
  },
  {
    text: "Queríamos conocer la vida nocturna de Lapa y el chofer nos dejó justo en la puerta del bar y después nos recogió a la 1 AM sin problemas. Súper recomendable para salir de noche.",
    name: "Carlos",
    flag: "🇦🇷",
    country: "Argentina",
    initial: "C",
    color: "#e67700",
  },
  {
    text: "As a solo female traveller, safety was my top priority. The driver was professional, the car was spotless, and I felt completely at ease the entire journey to Búzios.",
    name: "Emma",
    flag: "🇬🇧",
    country: "United Kingdom",
    initial: "E",
    color: "#5f3dc4",
  },
  {
    text: "Der Flug hatte 40 Minuten Verspätung, aber der Fahrer hat den Status live verfolgt und war pünktlich da. Keine Extrakosten, keine Diskussionen. Deutsche Effizienz trifft brasilianische Gastfreundschaft!",
    name: "Hans",
    flag: "🇩🇪",
    country: "Deutschland",
    initial: "H",
    color: "#0b7285",
  },
];

const gallery = [
  { name: "Arcos da Lapa", color: "#1a2332", image: "/gallery/arcos.webp" },
  { name: "Búzios", color: "#2d3a4f", image: "/gallery/buzios.webp" },
  { name: "Arraial do Cabo", color: "#1e2d3d", image: "/gallery/arraial.webp" },
  { name: "Cabo Frio", color: "#243447", image: "/gallery/cabofrio.webp" },
  { name: "Copacabana", color: "#1a2a3a", image: "/gallery/copacabana.webp" },
  { name: "Cristo Redentor", color: "#2a3a4a", image: "/gallery/cristo.webp" },
  { name: "Ipanema", color: "#1f3040", image: "/gallery/ipanema.webp" },
  { name: "Morro Dois Irmãos", color: "#253545", image: "/gallery/morro.webp" },
  {
    name: "Escadaria Selarón",
    color: "#253545",
    image: "/gallery/escadaria.webp",
  },
  {
    name: "Pão de Açúcar",
    color: "#253545",
    image: "/gallery/paodeacucar.webp",
  },
  { name: "Maracanã", color: "#253545", image: "/gallery/maracana.webp" },
  {
    name: "Vista Chinesa",
    color: "#253545",
    image: "/gallery/vistachinesa.webp",
  },
];

const getPayments = (t) => [
  { icon: <CreditCardIcon />, name: t.payCard },
  { icon: <PixIcon />, name: t.payPix },
  { icon: <MoneyIcon />, name: t.payCash },
  { icon: <GlobeIcon />, name: t.payOnline },
];

// ========== LANGUAGE SELECTOR ==========
const LanguageSelector = ({ lang, setLang }) => {
  return (
    <div className="lang-selector">
      <select value={lang} onChange={(e) => setLang(e.target.value)}>
        <option value="pt-BR">🇧🇷 Português</option>
        <option value="en-US">🇺🇸 English</option>
        <option value="es-ES">🇪🇸 Español</option>
      </select>
    </div>
  );
};

// ========== AVATAR COMPONENT ==========
const Avatar = ({ initial, color }) => (
  <div className="avatar" style={{ backgroundColor: color }}>
    {initial}
  </div>
);

// ========== QUOTE FORM COMPONENT ==========
const QuoteForm = ({ t }) => {
  const [formData, setFormData] = useState({
    origin: "",
    destination: "",
    date: "",
    time: "",
    passengers: 1,
    baggage: 1,
    nameOrFlight: "",
    childSeat: false,
    wifi: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const langLabels = {
      "pt-BR": {
        greeting: "Olá! Gostaria de solicitar uma cotação para transfer.",
        origin: "Origem",
        destination: "Destino",
        date: "Data",
        time: "Horário",
        passengers: "Passageiros",
        baggage: "Bagagens",
        name: "Número do voo",
        childSeat: "Cadeirinha infantil",
        wifi: "WiFi no carro",
        yes: "Sim",
        no: "Não",
      },
      "en-US": {
        greeting: "Hello! I would like to request a quote for a transfer.",
        origin: "Origin",
        destination: "Destination",
        date: "Date",
        time: "Time",
        passengers: "Passengers",
        baggage: "Baggage",
        name: "Flight number",
        childSeat: "Child seat",
        wifi: "WiFi in the car",
        yes: "Yes",
        no: "No",
      },
      "es-ES": {
        greeting: "¡Hola! Me gustaría solicitar una cotización para traslado.",
        origin: "Origen",
        destination: "Destino",
        date: "Fecha",
        time: "Hora",
        passengers: "Pasajeros",
        baggage: "Equipaje",
        name: "Número de vuelo",
        childSeat: "Silla de niño",
        wifi: "WiFi en el coche",
        yes: "Sí",
        no: "No",
      },
    };

    const l = langLabels[t.lang] || langLabels["pt-BR"];

    let message = `${l.greeting}\n\n`;
    message += `*${l.origin}:* ${formData.origin || "-"}\n`;
    message += `*${l.destination}:* ${formData.destination || "-"}\n`;
    message += `*${l.date}:* ${formData.date || "-"}\n`;
    message += `*${l.time}:* ${formData.time || "-"}\n`;
    message += `*${l.passengers}:* ${formData.passengers}\n`;
    message += `*${l.baggage}:* ${formData.baggage}\n`;
    if (formData.nameOrFlight) {
      message += `*${l.name}:* ${formData.nameOrFlight}\n`;
    }
    message += `*${l.childSeat}:* ${formData.childSeat ? l.yes : l.no}\n`;
    message += `*${l.wifi}:* ${formData.wifi ? l.yes : l.no}\n`;
    message += `\nAguardo retorno. Obrigado!`;

    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/5521999317877?text=${encodedMessage}`, "_blank");
  };

  return (
    <div className="quote-form-card" id="quote-form">
      <h3 className="quote-form-title">{t.formTitle}</h3>
      <form onSubmit={handleSubmit} className="quote-form">
        <div className="form-group">
          <label htmlFor="origin">{t.formOrigin}</label>
          <select
            id="origin"
            name="origin"
            value={formData.origin}
            onChange={handleChange}
            required
          >
            <option value="">{t.formPlaceholderOrigin}</option>
            <option value={t.originGaleao}>{t.originGaleao}</option>
            <option value={t.originSantosDumont}>{t.originSantosDumont}</option>
            <option value={t.originOther}>{t.originOther}</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="destination">{t.formDestination}</label>
          <input
            type="text"
            id="destination"
            name="destination"
            value={formData.destination}
            onChange={handleChange}
            placeholder={t.formPlaceholderDest}
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="date">{t.formDate}</label>
            <input
              type="date"
              id="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="time">{t.formTime}</label>
            <input
              type="time"
              id="time"
              name="time"
              value={formData.time}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="passengers">{t.formPassengers}</label>
            <input
              type="number"
              id="passengers"
              name="passengers"
              value={formData.passengers}
              onChange={handleChange}
              min="1"
              max="20"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="baggage">{t.formBaggage}</label>
            <input
              type="number"
              id="baggage"
              name="baggage"
              value={formData.baggage}
              onChange={handleChange}
              min="0"
              max="50"
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="nameOrFlight">{t.formNameOrFlight}</label>
          <input
            type="text"
            id="nameOrFlight"
            name="nameOrFlight"
            value={formData.nameOrFlight}
            onChange={handleChange}
            placeholder={t.formPlaceholderName}
          />
        </div>

        <div className="form-checkboxes">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="childSeat"
              checked={formData.childSeat}
              onChange={handleChange}
            />
            <span className="checkmark"></span>
            <span className="checkbox-text">{t.formChildSeat}</span>
          </label>
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="wifi"
              checked={formData.wifi}
              onChange={handleChange}
            />
            <span className="checkmark"></span>
            <span className="checkbox-text">{t.formWifi}</span>
          </label>
        </div>

        <button type="submit" className="quote-form-submit">
          {t.formSubmit}
        </button>
      </form>
    </div>
  );
};

// ========== MAIN APP ==========
function App() {
  const [lang, setLang] = useState("pt-BR");
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeVehicle, setActiveVehicle] = useState(0);
  const [expandedTour, setExpandedTour] = useState(null);
  const [vehicleImageIndex, setVehicleImageIndex] = useState(-1);
  const [touchStart, setTouchStart] = useState(null);
  const [expandedDestino, setExpandedDestino] = useState(null);

  useEffect(() => {
    setVehicleImageIndex(-1);
  }, [activeVehicle]);

  const t = translations[lang];
  t.lang = lang;

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  const features = getFeatures(t);
  const steps = getSteps(t);
  const vehicles = getVehicles(t);
  const testimonials = getTestimonials();
  const payments = getPayments(t);
  const cityTours = getCityTours(t);
  const destinos = getDestinos(t);

  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    if (touchStart === null) return;
    const diff = touchStart - e.changedTouches[0].clientX;
    const threshold = 50; // min swipe distance in px

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        // swiped left → next
        setActiveVehicle((prev) =>
          prev === vehicles.length - 1 ? 0 : prev + 1,
        );
      } else {
        // swiped right → previous
        setActiveVehicle((prev) =>
          prev === 0 ? vehicles.length - 1 : prev - 1,
        );
      }
    }
    setTouchStart(null);
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      <div className="app">
        {/* Navigation */}
        <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
          <div className="nav-container">
            <Logo />
            <div className="nav-right">
              <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
                <li onClick={() => scrollTo("destinos")}>{t.navRoutes}</li>
                <li onClick={() => scrollTo("vehicles")}>{t.navVehicles}</li>
                <li onClick={() => scrollTo("gallery")}>{t.navGallery}</li>
                <li onClick={() => scrollTo("contact")}>{t.navContact}</li>
              </ul>
              <LanguageSelector lang={lang} setLang={setLang} />
              <a
                href="https://instagram.com/rioexecutivetransfer"
                className="nav-instagram"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>
              <a
                href="https://wa.me/5521999317877"
                className="nav-cta"
                target="_blank"
                rel="noreferrer"
              >
                <WhatsAppIcon /> WhatsApp
              </a>
            </div>
            <button
              className="menu-toggle"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </nav>

        {/* Hero */}
        <section id="hero" className="hero">
          <div className="hero-overlay"></div>
          <div className="hero-car-image">
            <img
              src="/riodejaneiro.jpg"
              alt="Rio de Janeiro"
              className="hero-car-img"
            />
          </div>
          <div className="hero-container">
            <div className="hero-content">
              <span className="hero-badge">{t.badge}</span>
              <h1>{t.heroTitle}</h1>
              <p>{t.heroSubtitle}</p>
              <div className="hero-buttons">
                <button
                  className="btn-secondary"
                  onClick={() => scrollTo("destinos")}
                >
                  {t.heroSecondary}
                </button>
              </div>
            </div>
            <QuoteForm t={t} />
          </div>
          <div className="hero-scroll" onClick={() => scrollTo("features")}>
            <div className="scroll-mouse">
              <div className="scroll-wheel"></div>
            </div>
          </div>
        </section>

        {/* Vehicles Carousel */}
        <section id="vehicles" className="vehicles">
          <div className="container">
            <h2 className="section-title">{t.vehiclesTitle}</h2>

            {/* Tabs */}
            <div className="vehicle-tabs">
              {vehicles.map((v, i) => (
                <button
                  key={i}
                  className={`vehicle-tab ${activeVehicle === i ? "active" : ""}`}
                  onClick={() => setActiveVehicle(i)}
                >
                  {v.name}
                </button>
              ))}
            </div>

            {/* Carousel */}
            <div className="vehicle-carousel">
              <button
                className="vehicle-arrow vehicle-arrow-prev"
                onClick={() =>
                  setActiveVehicle((prev) =>
                    prev === 0 ? vehicles.length - 1 : prev - 1,
                  )
                }
                aria-label="Anterior"
                type="button"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="15 18 9 12 15 6" />
                </svg>
              </button>

              <div
                className="vehicle-carousel-track"
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
              >
                {vehicles.map((v, i) => {
                  const isActive = activeVehicle === i;
                  const currentImage =
                    vehicleImageIndex === -1
                      ? v.image
                      : v.extraImages[vehicleImageIndex].image;

                  return (
                    <div
                      key={i}
                      className={`vehicle-slide ${isActive ? "active" : ""}`}
                      style={{
                        transform: `translateX(${(i - activeVehicle) * 100}%)`,
                      }}
                    >
                      <div className="vehicle-card">
                        {/* Left: Images */}
                        <div className="vehicle-visual">
                          <div
                            className="vehicle-main-image-wrap"
                            onClick={() =>
                              vehicleImageIndex !== -1 &&
                              setVehicleImageIndex(-1)
                            }
                            style={{
                              cursor:
                                vehicleImageIndex !== -1
                                  ? "pointer"
                                  : "default",
                            }}
                            title={
                              vehicleImageIndex !== -1
                                ? t.clickToReturn
                                : undefined
                            }
                          >
                            <img
                              src={currentImage}
                              alt={v.name}
                              className="vehicle-main-image"
                              loading="lazy"
                            />
                          </div>

                          <div className="vehicle-thumbnails">
                            {v.extraImages.map((extra, idx) => (
                              <button
                                key={idx}
                                className={`vehicle-thumb ${vehicleImageIndex === idx ? "active" : ""}`}
                                onClick={() => setVehicleImageIndex(idx)}
                                type="button"
                              >
                                <div className="thumb-image-wrap">
                                  <img
                                    src={extra.image}
                                    alt={`${v.name} ${idx + 1}`}
                                    loading="lazy"
                                  />
                                </div>
                              </button>
                            ))}
                          </div>
                        </div>

                        {/* Right: Info */}
                        <div className="vehicle-info">
                          <h3>{v.name}</h3>
                          <p className="vehicle-passengers">{v.passengers}</p>
                          <ul className="vehicle-features">
                            {v.features.map((f, idx) => (
                              <li key={idx}>
                                <StarIcon /> {f}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <button
                className="vehicle-arrow vehicle-arrow-next"
                onClick={() =>
                  setActiveVehicle((prev) =>
                    prev === vehicles.length - 1 ? 0 : prev + 1,
                  )
                }
                aria-label="Próximo"
                type="button"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </button>
            </div>

            {/* Dots */}
            <div className="vehicle-dots">
              {vehicles.map((_, i) => (
                <button
                  key={i}
                  className={`vehicle-dot ${activeVehicle === i ? "active" : ""}`}
                  onClick={() => setActiveVehicle(i)}
                  aria-label={`Ir para ${i + 1}`}
                  type="button"
                />
              ))}
            </div>
          </div>
        </section>

        {/* City Tours */}
        <section id="city-tours" className="city-tours">
          <div className="container">
            <h2 className="section-title">{t.cityToursTitle}</h2>
            <div className="city-tours-grid">
              {cityTours.map((tour, i) => {
                const isPersonalizado = i === cityTours.length - 1;
                const isExpanded = expandedTour === i;

                if (isPersonalizado) {
                  return (
                    <div className="city-tour-card personalizado" key={i}>
                      <div className="personalizado-content">
                        <div className="personalizado-icon">
                          <StarIcon />
                        </div>
                        <div className="personalizado-text">
                          <span className="city-tour-label">
                            {t.cityTourLabel}
                          </span>
                          <h3>{tour.title.replace(/City Tour\s*/i, "")}</h3>
                          <p>{tour.items[0]}</p>
                        </div>
                        <a
                          href={`https://wa.me/5521999317877?text=${encodeURIComponent(t.tourCustomMsg)}`}
                          className="personalizado-cta"
                          target="_blank"
                          rel="noreferrer"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <WhatsAppIcon /> {t.tourCustomCta}
                        </a>
                      </div>
                    </div>
                  );
                }

                const tourImages = [
                  "/tour-photos/asset_1.jpg", // Cristo Redentor
                  "/tour-photos/asset_2.jpg", // Pão de Açúcar / cable car
                  "/tour-photos/asset_3.jpg", // Candelária Church
                  "/tour-photos/asset_4.jpg", // Jardim Botânico
                  "/tour-photos/asset_5.jpg", // Copacabana
                  "/tour-photos/asset_6.jpg", // Museu do Amanhã
                ];

                const tourIcons = [
                  <ColumnIcon />, // Clássico
                  <CameraTourIcon />, // Completo
                  <BuildingIcon />, // Histórico
                  <LeafIcon />, // Natureza
                  <WavesIcon />, // Praias
                  <MuseumIcon />, // Cultural
                ];

                return (
                  <div
                    className={`city-tour-card ${isExpanded ? "expanded" : ""}`}
                    key={i}
                    onClick={() => setExpandedTour(isExpanded ? null : i)}
                  >
                    <div className="city-tour-image-wrap">
                      <img
                        src={tourImages[i]}
                        alt={tour.title}
                        className="city-tour-image"
                        loading="lazy"
                      />
                    </div>
                    <div className="city-tour-content">
                      <div className="city-tour-icon">{tourIcons[i]}</div>
                      <div className="city-tour-title-wrap">
                        <span className="city-tour-label">CITY TOUR</span>
                        <h3>{tour.title.replace(/City Tour\s*/i, "")}</h3>
                      </div>
                      <span className="city-tour-chevron">
                        <ChevronRight />
                      </span>
                    </div>
                    <div className="city-tour-details">
                      <ul className="city-tour-list">
                        {tour.items.map((item, j) => (
                          <li key={j}>
                            <span className="city-tour-bullet"></span>
                            {item}
                          </li>
                        ))}
                      </ul>
                      <a
                        href={`https://wa.me/5521999317877?text=${encodeURIComponent(`Olá! Gostaria de reservar o ${tour.title}.`)}`}
                        className="tour-cta"
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <WhatsAppIcon /> {t.tourCustomCta}
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Features */}
        <section id="features" className="features">
          <div className="container">
            <h2 className="section-title">{t.featuresTitle}</h2>
            <div className="features-grid">
              {features.map((f, i) => (
                <div className="feature-card" key={i}>
                  <div className="feature-icon">{f.icon}</div>
                  <h3>{f.title}</h3>
                  <p>{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Destinos */}
        <section id="destinos" className="destinos">
          <div className="container">
            <h2 className="section-title">{t.destinosTitle}</h2>
            <div className="destinos-grid">
              {destinos.map((d, i) => {
                const isExpanded = expandedDestino === i;
                return (
                  <div
                    className={`destino-card ${isExpanded ? "expanded" : ""}`}
                    key={i}
                    onClick={() => setExpandedDestino(isExpanded ? null : i)}
                  >
                    <div
                      className="destino-card-bg"
                      style={{ backgroundImage: `url(${d.image})` }}
                    />
                    <div className="destino-card-content">
                      <div className="destino-icon">{d.icon}</div>
                      <div className="destino-text">
                        <h3>{d.title}</h3>
                        <p>{d.subtitle}</p>
                      </div>
                      <span className="destino-chevron">
                        <ChevronRight />
                      </span>
                    </div>
                    <div className="destino-details">
                      <ul className="destino-list">
                        {d.destinations.map((dest, j) => (
                          <li key={j}>
                            <span className="destino-bullet"></span>
                            {dest}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="how-it-works">
          <div className="container">
            <h2 className="section-title">{t.howTitle}</h2>
            <div className="steps">
              {steps.map((s, i) => (
                <div className="step" key={i}>
                  <div className="step-num">{s.num}</div>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="testimonials">
          <div className="container">
            <h2 className="section-title">{t.testiTitle}</h2>
            <div className="testimonials-grid">
              {testimonials.map((tItem, i) => (
                <div className="testimonial-card" key={i}>
                  <div className="testimonial-stars">★★★★★</div>
                  <p className="testimonial-text">"{tItem.text}"</p>
                  <div className="testimonial-author">
                    <Avatar initial={tItem.initial} color={tItem.color} />
                    <div className="testimonial-meta">
                      <strong>{tItem.name}</strong>
                      <span>
                        {tItem.flag} {tItem.country}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Gallery */}
        <section id="gallery" className="gallery">
          <div className="container">
            <h2 className="section-title">{t.galleryTitle}</h2>
            <div className="gallery-grid">
              {gallery.map((g, i) => (
                <a
                  key={i}
                  className="gallery-item"
                  href="https://wa.me/5521999317877"
                  target="_blank"
                  rel="noreferrer"
                  style={{ backgroundColor: g.color }}
                >
                  <img src={g.image} alt={g.name} className="gallery-image" />
                  <div className="gallery-overlay">
                    <span>{g.name}</span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* Payment */}
        <section className="payment">
          <div className="container">
            <h2 className="section-title">{t.paymentTitle}</h2>
            <p className="payment-subtitle">{t.paymentSub}</p>
            <div className="payment-grid">
              {payments.map((p, i) => (
                <div className="payment-card" key={i}>
                  <div className="payment-icon">{p.icon}</div>
                  <span>{p.name}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

{/* Cadastur Badge */}
<section className="cadastur">
  <div className="container">
    <div className="cadastur-card">
      <div className="cadastur-icon">
        <CheckIcon />
      </div>
      <div className="cadastur-text">
        <h3>{t.cadastur}</h3>
        <p>{t.cadasturDesc}</p>
      </div>
      <img
        src="/gallery/cadastrur.jpeg"
        alt="Cadastur"
        className="cadastur-logo-img"
      />
    </div>
  </div>
</section>

        {/* Contact / CTA */}
        <section id="contact" className="contact">
          <div className="container">
            <div className="cta-card">
              <div className="cta-icon">
                <CalendarIcon />
              </div>
              <h2>{t.ctaTitle}</h2>
              <p>{t.ctaSub}</p>
              <div className="cta-buttons">
                <a
                  href="https://api.whatsapp.com/send?phone=5521999317877"
                  className="btn-primary btn-large cta-whatsapp-btn"
                  target="_blank"
                  rel="noreferrer"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(
                      "https://api.whatsapp.com/send?phone=5521999317877",
                      "_blank",
                    );
                  }}
                >
                  <WhatsAppIcon /> {t.ctaBtn}
                </a>
                <a
                  href="#quote-form"
                  className="btn-secondary"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollTo("quote-form");
                  }}
                >
                  {t.heroCtaForm}
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <div className="footer-content">
              <div className="footer-brand">
                <Logo />
                <p>{t.footerDesc}</p>
              </div>
              <div className="footer-links">
                <h4>{t.footerLinks}</h4>
                <ul>
                  <li onClick={() => scrollTo("destinos")}>{t.navRoutes}</li>
                  <li onClick={() => scrollTo("vehicles")}>{t.navVehicles}</li>
                  <li onClick={() => scrollTo("gallery")}>{t.navGallery}</li>
                  <li onClick={() => scrollTo("contact")}>{t.navContact}</li>
                </ul>
              </div>
              <div className="footer-contact">
                <h4>{t.footerContact}</h4>
                <a
                  href="https://wa.me/5521999317877"
                  className="footer-contact-item footer-whatsapp"
                  target="_blank"
                  rel="noreferrer"
                >
                  <WhatsAppIcon />
                  <span>+55 21 9931-7877</span>
                </a>
                <a
                  href="mailto:transfertour24h@gmail.com"
                  className="footer-contact-item footer-email"
                >
                  <MailIcon />
                  <span>transfertour24h@gmail.com</span>
                </a>
                <div className="footer-bottom-row">
                <a
                  href="https://instagram.com/rioexecutivetransfer"
                  className="footer-contact-item footer-instagram"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                >
                  <InstagramIcon />
                </a>
                <span className="footer-24h-badge">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                  {t.feat24h}
                </span>
                </div>
              </div>
            </div>
            <div className="footer-bottom">
              <p>{t.footerCopy}</p>
            </div>
          </div>
        </footer>

        {/* Floating WhatsApp */}
        <a
          href="https://wa.me/5521999317877"
          className="whatsapp-float"
          target="_blank"
          rel="noreferrer"
        >
          <WhatsAppIcon />
        </a>
      </div>
    </LangContext.Provider>
  );
}

export default App;
